import React from "react";
import { PrimaryButton, Title } from "../../../router";
import { NavLink } from "react-router-dom";
import { AiOutlinePlus } from "react-icons/ai";

export const ProductList = () => {
  return (
    <>
      <section className="p-8 rounded-lg shadow-s1">
        <div className="flex justify-between">
          <Title level={5} className="font-normal ">
            Product Lists
          </Title>
          <NavLink to="/create-product">
            <PrimaryButton className="flex items-center gap-3 px-5 py-2 text-sm transition-transform rounded-md hover:scale-105">
              <AiOutlinePlus size={20} />
              <span>Add Alert Content</span>
            </PrimaryButton>
          </NavLink>
        </div>
        <hr className="my-5" />
      </section>
    </>
  );
};
